/* eslint-disable */
import { ReactElement } from "react";
import { observer } from "mobx-react-lite";
import { Button, Popconfirm, Spin } from "antd";
import { ArrowLeftOutlined, CreditCardOutlined } from "@ant-design/icons";
import { useStore } from "../../../../stores/root-store-context";
import { TypeAddModal } from "../../../../stores/RicStore";
import { useNavigate } from "react-router-dom";
import AccountInfoCard from "./AccountInfoCard";
import AddContactInfoModal from "../AddContactInfoModal";

const AccountInfoBlock = observer((): ReactElement => {
  const { ricStore, applicationStore } = useStore();
  const navigate = useNavigate();
  return (
    <>
      {ricStore.accountInformation?.accountNumber && (
        <>
          <div className="ric-account__actions">
            <div className="ric-account__action">
              <Button
                className="ric-pill-btn"
                data-testid="ric-back-btn"
                onClick={() => navigate("/AAM/ric", { state: { PrpertyApiCall: true } })}
              >
                <ArrowLeftOutlined /> Back
              </Button>
            </div>

            {(!ricStore.accountInformation?.futuresAccNumbers ||
              ricStore.accountInformation.futuresAccNumbers.length === 0) &&
              ricStore.accountInformation.isMainAcc &&
              ricStore.accountInformation?.isETrakType && (
                <div className="ric-account__action ric-account__action--fixed">
                  <AddContactInfoModal text="Add Future Account" type={TypeAddModal.AddFeatureContact} variant="pill" />
                </div>
              )}

            {(!ricStore.accountInformation?.rentersAccNumbers ||
              ricStore.accountInformation.rentersAccNumbers.length === 0) &&
              ricStore.accountInformation.isMainAcc &&
              ricStore.accountInformation?.isETrakType && (
                <div className="ric-account__action ric-account__action--fixed">
                  <AddContactInfoModal text="Add Renter Account" type={TypeAddModal.AddRentedContact} variant="pill" />
                </div>
              )}

            <div className="ric-account__action ric-account__action--fixed">
              <Spin spinning={ricStore.isLoadLoaderZEGO}>
                <Button
                  data-testid="ric-zego-pay-btn"
                  block
                  onClick={() => {
                    ricStore.createPdf();
                  }}
                  className="ric-pill-btn"
                >
                  <CreditCardOutlined /> ZEGO Pay Now Info
                </Button>
              </Spin>
            </div>

            {ricStore.accountInformation?.rentersAccNumbers &&
              (ricStore.accountInformation.rentersAccNumbers.length > 0 ||
                ricStore.accountInformation.futuresAccNumbers.length > 0) &&
              ricStore.accountInformation.isMainAcc !== true && (
                <div className="ric-account__action">
                  <Button className="ric-pill-btn" data-testid="ric-return-main-acc-btn" onClick={ricStore.toMainAcc}>
                    Return to Main Account
                  </Button>
                </div>
              )}

            {ricStore.accountInformation?.rentersAccNumbers &&
              ricStore.accountInformation.rentersAccNumbers.length > 0 &&
              ricStore.accountInformation.isMainAcc === true && (
                <div className="ric-account__action">
                  <Button className="ric-pill-btn" data-testid="ric-access-renter-btn" onClick={ricStore.accesAccountRenter}>
                    Access Linked Renter Account
                  </Button>
                </div>
              )}

            {ricStore.accountInformation?.futuresAccNumbers &&
              ricStore.accountInformation.futuresAccNumbers.length > 0 &&
              ricStore.accountInformation.isMainAcc === true && (
                <div className="ric-account__action">
                  <Button className="ric-pill-btn" data-testid="ric-access-future-btn" onClick={ricStore.accesAccountFuture}>
                    Access Linked Future Account
                  </Button>
                </div>
              )}

            {ricStore.accountInformation.subLedgerType === "Renter" && (
              <div className="ric-account__action">
                <Popconfirm
                  title="DEACTIVATE ACCOUNT"
                  description={
                    <div className="ric-confirm-text">
                      Are you sure you want to deactivate this account? This is
                      not reversible and <br />
                      the account will lose access to all AAM systems.
                    </div>
                  }
                  okText="Confirm"
                  cancelText="Cancel"
                  onConfirm={() => {
                    ricStore
                      .deactivateAccountRenter()
                      .then((res) => {
                        ricStore.setIsLoadingApp(true);
                        setTimeout(async () => {
                          await ricStore.getFilterList(
                            applicationStore.SelectedProperties.id
                          );
                          ricStore.toMainAcc();
                        }, 5000);
                      })
                      .catch(console.log);
                  }}
                >
                  <Button
                    className="ric-pill-btn ric-pill-btn--danger"
                    data-testid="ric-deactivate-renter-btn"
                    disabled={
                      !ricStore.isEditable ||
                      !ricStore.accountInformation?.isETrakType ||
                      !(ricStore.filterList?.eTrakAccounts?.length > 0)
                    }
                  >
                    Deactivate Renter Acct
                  </Button>
                </Popconfirm>
              </div>
            )}
          </div>

          <div style={{ margin: "8px 0", minWidth: 0 }}>
            <AccountInfoCard
              key={"accountInfo"}
              accountInfo={ricStore.accountInformation}
            />
          </div>
        </>
      )}
    </>
  );
});

export default AccountInfoBlock;
